// src/components/lessons/renderers/WarningRenderer.jsx
import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const WarningRenderer = ({ block, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div
        style={{
          background: '#FFFFFF',
          border: '2px solid #000000',
          borderLeft: '4px solid #000000',
          padding: isMobile ? '1rem 1.25rem' : '1.25rem 1.5rem',
          borderRadius: '0.5rem',
          boxShadow: isHovered ? '0 4px 16px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: isHovered ? 'translateX(4px)' : 'translateX(0)',
          position: 'relative'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={{
          display: 'flex',
          gap: '0.75rem',
          alignItems: 'flex-start'
        }}>
          {/* Warning icon */}
          <div style={{ flexShrink: 0 }}>
            <div style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#000000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'transform 0.3s ease',
              transform: isHovered ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)'
            }}>
              <AlertTriangle
                style={{
                  width: '16px',
                  height: '16px',
                  color: '#3A86FF'
                }}
                aria-hidden="true"
              />
            </div>
          </div>

          {/* Warning content */}
          <div style={{ flex: 1 }}>
            <p style={{
              fontSize: isMobile ? '0.9rem' : '0.95rem',
              color: '#000000',
              lineHeight: '1.7',
              margin: 0,
              opacity: 0.9
            }}>
              {block.content}
            </p>
          </div>

          {/* Decorative dot */}
          {isHovered && (
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: '#3A86FF',
              marginTop: '0.5rem',
              flexShrink: 0
            }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default WarningRenderer;